import GetItemFromLocalstorage from "Utils/GetItemFromLocalstorage";

export const applyPlatformSessionPayload = (sessionPayload = {}) => {
  const user = GetItemFromLocalstorage("user");
  if (!user || typeof sessionPayload !== "object") {
    return { user: null, changed: false };
  }

  const previousFingerprint = user.platform_permissions_fingerprint ?? null;
  const nextFingerprint = sessionPayload.permissions_fingerprint ?? null;
  const changed =
    Boolean(nextFingerprint) &&
    Boolean(previousFingerprint) &&
    previousFingerprint !== nextFingerprint;

  const nextUser = {
    ...user,
    platform_roles: sessionPayload.platform_roles ?? user.platform_roles,
    platform_permissions: sessionPayload.platform_permissions ?? user.platform_permissions,
    platform_permissions_fingerprint: nextFingerprint ?? previousFingerprint,
    platform_permissions_refreshed_at: sessionPayload.refreshed_at ?? user.platform_permissions_refreshed_at,
  };

  localStorage.setItem("user", JSON.stringify(nextUser));

  return { user: nextUser, changed };
};

export const readPlatformPermissionsFingerprint = () => {
  const user = GetItemFromLocalstorage("user");
  return user?.platform_permissions_fingerprint ?? null;
};
